import { RutinUrvalType } from '../../../../../Types/UrvalTypes';

export const getInitialUrval = (
  rutinUrvalList: RutinUrvalType[],
  initialUrvalId: string | undefined
) => {
  const initalUrval = rutinUrvalList.find(urval => urval.id === initialUrvalId);
  const favoritUrval = rutinUrvalList.find(urval => urval.anvFavorit === true);
  const rutinStandardUrval = rutinUrvalList.find(
    urval => urval.rutinStandard === true
  );

  if (initalUrval != null) {
    return initalUrval;
  } else if (favoritUrval != null) {
    return favoritUrval;
  } else if (rutinStandardUrval != null) {
    return rutinStandardUrval;
  } else if (rutinUrvalList.length > 0) {
    return rutinUrvalList[0];
  } else {
    return undefined;
  }
};
